import { Alert, Button, Flex, Form, Input } from 'antd'
import { Api } from '~/core/trpc'

type FormValues = { password: string; passwordConfirmation: string }

type Props = {
  token: string
  onError: (key: string) => void
  onNext: (key: string) => void
}

export const StepPasswordForgotToken: React.FC<Props> = ({
  token,
  onError,
  onNext,
}) => {
  const [form] = Form.useForm<FormValues>()

  const resetPassword = Api.authentication.resetPassword.useMutation()

  const handleSubmit = async (values: FormValues) => {
    if (resetPassword.isLoading) {
      return
    }

    const isPasswordConfirmationOk =
      values.password === values.passwordConfirmation

    if (!isPasswordConfirmationOk) {
      onError(`bad-password-confirmation`)
      return
    }

    try {
      await resetPassword.mutateAsync({ token, password: values.password })
    } catch (error) {
      console.error('Unknown Error', error)
      onError('offline')
    }
  }

  const isSuccess = resetPassword.isSuccess

  return (
    <>
      <Flex vertical gap={16}>
        {isSuccess && (
          <>
            <Alert
              style={{ textAlign: 'center' }}
              message="Your password has been changed"
              type="success"
            />

            <Button type="primary" onClick={() => onNext('email')}>
              Login
            </Button>
          </>
        )}

        {!isSuccess && (
          <Form
            onFinish={handleSubmit}
            form={form}
            layout="vertical"
            requiredMark={false}
          >
            <Form.Item
              name="password"
              label="New password"
              rules={[{ required: true, message: 'New password is required' }]}
            >
              <Input.Password minLength={6} />
            </Form.Item>

            <Form.Item
              name="passwordConfirmation"
              label="New password confirmation"
              rules={[
                {
                  required: true,
                  message: 'New password confirmation is required',
                },
              ]}
            >
              <Input.Password minLength={6} />
            </Form.Item>

            <Button
              htmlType="submit"
              block
              type="primary"
              loading={resetPassword.isLoading}
            >
              Reset Password
            </Button>
          </Form>
        )}
      </Flex>
    </>
  )
}
